export default {
  id: "id",
  name: "title",
  isEnabled: "is_enabled",
  programConditions: "program_conditions",
  introductoryVideoPath: "introductory_video_path",
};
